import { Pencil2Icon } from '@radix-ui/react-icons';
import { IconButton, Tooltip } from '@raystack/apsara';

import { HEADER_ICON_COLOR } from '@src/components/Custom/Header/Header';
import { useCopilotDispatch } from '@src/contexts';
import { MULTI_CHAT_STEPS } from '@src/utils/constants/COPILOT_CONSTANTS';

export const CreateChat = () => {
  const dispatch = useCopilotDispatch();
  return (
    <Tooltip message='Create new chat' side='bottom'>
      <IconButton
        size={3}
        onClick={() =>
          dispatch({
            multiChatStep: MULTI_CHAT_STEPS.WELCOME,
            chatId: '',
            msgFetchFailed: false
          })
        }
        data-test-id='create-chat'
      >
        <Pencil2Icon color={HEADER_ICON_COLOR} />
      </IconButton>
    </Tooltip>
  );
};
